module.exports = __webpack_public_path__ + "zjsg.png?398ee773be53356502dd811b5022921f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zjsg.png
// module id = 620
// module chunks = 0